import round from 'lodash/round';
import Field from '../Field';

const _ = {
  round,
};

const regex = /^-?\$?(([0-9]{1,3}|\.),?([0-9]{3},)*[0-9]*\.?(\d+)?)$/;
const notApplicable = /^[Nn]\/?[Aa]$/;
const NA_STRING = 'N/A';

class Currency extends Field {
  sanitize(force = false) {
    super.sanitize(force);

    // Ensure precision is a number before running with it
    const precision = /^\d+$/.test(this.config.precision) ? this.config.precision : 2;

    this.value.forEach((val, index) => {
      if (val === undefined) {
        return;
      }

      if (val === '' || val === null) {
        val = '';
      }

      if (this.config.allowNA) {
        if (notApplicable.test(val)) {
          val = NA_STRING;
          this.setValue(NA_STRING, index);
          this.setDisplayValue(NA_STRING, index);
          return;
        }
      }

      if (!/\d+/.test(val)) {
        val = '';
      }

      if (force || this.validIndex[index]) {
        if (!val.match) {
          val = String(val);
        }

        const matches = val.match(regex);
        if (matches && matches[1]) {
          const isNegative = /^-/.test(val);

          const newValue = parseFloat(_.round(matches[1].replace(/[$,]*/g, ''), precision));
          let rawValue = newValue.toFixed(precision);
          let displayValue = `$${Field.commaize(newValue, precision)}`;

          if (isNegative) {
            rawValue = `-${rawValue}`;
            displayValue = `-${displayValue}`;
          }

          this.setValue(rawValue, index);
          this.setDisplayValue(displayValue, index);
        }
      }
    });

    return this;
  }

  validate() {
    super.validate();

    this.value.forEach((val, index) => {
      if (Field.isEmpty(val) && !this.isRequired(index)) {
        return;
      }

      if (this.config.allowNA) {
        if (notApplicable.test(val)) {
          return;
        }
      }

      if (!regex.test(val) || !/\d+/.test(val)) {
        this.invalidate('Invalid currency.', index);
      }
    });

    return this.isValid();
  }
}

export default Currency;
